import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { SEND_CHAT, SEND_CHAT_SUCCESS, SEND_CHAT_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';
import cogoToast from 'cogo-toast';

function* sendChat({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    // const { clientId, programId, userId } = payload?.data;

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/ticket-system/tickets/chat-reply`,
      method: 'POST',
      data: payload?.data,
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
        // withCredentials: true
      }
    });

    if (response.status === 200 || response.status === 201) {
      // cogoToast.success(`${response?.data?.message}`);

      yield put({
        type: SEND_CHAT_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(`${response?.response?.data?.message}`);
      yield put({
        type: SEND_CHAT_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: SEND_CHAT_ERROR, payload: error });
  }
}

export function* watchSendChat() {
  yield takeEvery(SEND_CHAT, sendChat);
}

function* sendChatSaga() {
  yield all([fork(watchSendChat)]);
}

export default sendChatSaga;
